export const GRAPHQL_ENDPOINT = "/api/screen-graphql"
export const GRAPHQL_BASE_ENDPOINT = "/api"
export const FACTORBOOK_GRAPHQL_ENDPOINT = "/api/factorbook-graphql"
